let pendingCredentials = null
const accountKey = 'adminPasswordLoginAccount'

// Consume admin links before the hash router and saved-account restoration start.
export function preparePasswordLogin(location = window.location, history = window.history) {
    const prefix = /^\/login\/passwordlogin(?:\/|$)/
    const legacyPath = prefix.test(location.pathname)
    const path = legacyPath ? location.pathname : location.hash.slice(1).split('?')[0]

    if (!prefix.test(path)) return

    pendingCredentials = { login: '', password: '' }
    const match = /^\/login\/passwordlogin\/([^/]+)\/([^/]+)\/?$/.exec(path)
    if (match) {
        try {
            pendingCredentials = {
                login: decodeURIComponent(match[1]),
                password: decodeURIComponent(match[2]),
            }
        } catch {
            // Malformed links must show the login form instead of restoring another user.
        }
    }

    const base = legacyPath ? '/' : location.pathname
    history.replaceState(history.state, '', `${base}${location.search}#/`)
}

export function takePasswordLoginCredentials() {
    const credentials = pendingCredentials
    pendingCredentials = null
    return credentials
}

export function rememberPasswordLoginAccount(login, storage) {
    try {
        (storage || window.sessionStorage).setItem(accountKey, login)
    } catch {
        // Authentication can still proceed when tab storage is unavailable.
    }
}

export function prioritizePasswordLoginAccount(accounts, storage) {
    try {
        const login = (storage || window.sessionStorage).getItem(accountKey)
        if (!login) return accounts
        return [...accounts].sort((a, b) => Number(b.login === login) - Number(a.login === login))
    } catch {
        return accounts
    }
}
